{{text}}
<span *ngIf="hasClose" (click)="closeOverlay()"><i class="icon icon-close-thick"></i></span>
